import { RgChildren as t } from "@project-rouge/rg-core";
const n = (r) => (e) => r === void 0 ? !0 : t.Building.includes(e.type) ? e.data.level === r : !0;
export {
  n as RgFilterByLevel
};
//# sourceMappingURL=index10.js.map
